document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll('.section--slider');
  const toggleBtns = document.querySelectorAll('.varient-selected');
  const dropdownBoxes = document.querySelectorAll('.varient-dropdown');

  sliders.forEach((sliderContainer) => {
    const slides = sliderContainer.querySelector('.product--slider');
    const prevButton = sliderContainer.querySelector('.prev');
    const nextButton = sliderContainer.querySelector('.next');
    const slideCountContainer = sliderContainer.querySelector('.counter');
    let slideIndex = 0;
    let totalSlides;
   
    if (!slides) return;
    totalSlides = slides.children.length;
    
    if (totalSlides <= 1) {
      if (totalSlides === 1) {
        slides.children[0].classList.add("active");
      }
      return;
    }

    function showSlides(n) {
      if (n >= totalSlides) { slideIndex = 0; }
      if (n < 0) { slideIndex = totalSlides - 1; }

      slides.style.transform = `translateX(-${slideIndex * 100}%)`;

      for (let i = 0; i < totalSlides; i++) {
        slides.children[i].classList.remove("active");
      }

      if (totalSlides > 0) {
        slides.children[slideIndex].classList.add("active");
      }

      const activeSlideNumber = slideIndex + 1;
      slideCountContainer.textContent = `${activeSlideNumber} of ${totalSlides}`;
    }

    function moveSlide(n) {
      showSlides(slideIndex += n);
    }

    showSlides(slideIndex);

    prevButton.addEventListener('click', () => moveSlide(-1));
    nextButton.addEventListener('click', () => moveSlide(1));
  });


  toggleBtns.forEach(function(toggleBtn, index) {
    toggleBtn.addEventListener('click', function() {
      const dropdownBox = dropdownBoxes[index];
      if (dropdownBox.classList.contains('show')) {
        dropdownBox.classList.remove('show');
      } else {
        dropdownBox.classList.add('show');
      }
    });
  });
});